document.addEventListener('DOMContentLoaded', function() {
  // --- Gestore Centralizzato per tutti i Popup ---
  let openModalCount = 0;
  const body = document.body;

  // Funzione da chiamare quando QUALSIASI popup si apre
  function onModalOpen() {
    if (openModalCount === 0) {
      body.classList.add('modal-is-open');
    }
    openModalCount++;
  }

  // Funzione da chiamare quando QUALSIASI popup si chiude
  function onModalClose() {
    openModalCount--;
    if (openModalCount === 0) {
      body.classList.remove('modal-is-open');
    }
  }

  // --- Logica Specifica per la Size Guide ---
  const modal = document.getElementById("size-guide-modal");
  if (!modal) return; // Esce se il modal non esiste

  // Sposta il modal alla fine del body per evitare problemi di z-index
  body.appendChild(modal);

  const trigger = document.querySelector(".size-guide-trigger");
  const closeBtn = document.querySelector(".size-guide-close");

  function openSizeGuide() {
    modal.classList.add('is-visible');
    onModalOpen(); // Usa il gestore centralizzato
  }

  function closeSizeGuide() {
    modal.classList.remove('is-visible');
    onModalClose(); // Usa il gestore centralizzato
  }

  // Associa gli eventi
  if (trigger) {
    trigger.onclick = openSizeGuide;
  }

  if (closeBtn) {
    closeBtn.onclick = closeSizeGuide;
  }

  // Chiude se si clicca sullo sfondo o si preme 'Esc'
  modal.addEventListener('click', function(event) {
    if (event.target === modal) {
      closeSizeGuide();
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && modal.classList.contains('is-visible')) {
      closeSizeGuide();
    }
  });
});